/** @jsxImportSource @emotion/react */

import { HeaderUser } from "components/ui/user/HeaderUser";
import { UserWrapperPage } from "components/ui/user/UserWrapperPage";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { selectUsername } from "store/auth";
import { getMemberVip } from "store/member/member.thunk";

import Benefits from "./Benefits";
import RankStatus from "./RankStatus";
import { MemberVipPageStyle } from "./style.index";
import VipConditions from "./VipConditions";
import VipPointsHistory from "./VipPointsHistory";
import VipPointsTurnover from "./VipPointsTurnover";

const MemberVipPage = () => {
  const { t } = useTranslation(["common", "vip"]);
  const dispatch = useAppDispatch();
  const username = useAppSelector(selectUsername);

  useEffect(() => {
    if (!username) return;

    dispatch(getMemberVip({ username }));
  }, [username]);

  return (
    <UserWrapperPage hasMaxWidth>
      <HeaderUser title={t("vip:myvip")} />
      <div css={MemberVipPageStyle.wrapper}>
        <RankStatus />
        {username === "testing001" && <VipPointsTurnover />}
        {username === "testing001" && <VipPointsHistory />}
        <Benefits />
        <VipConditions />
      </div>
    </UserWrapperPage>
  );
};

export default MemberVipPage;
